﻿import React, { useState, useEffect } from 'react';


const ButtonComponent = (props) => {
    let [showButton, setShowButton] = useState(false);

    window.addEventListener('message', (event) => {
        const { data } = event;

        if (!data.value) {
            return
        }

        if (data.value === 'DATA_AGGREGATION_RESULTS' || data.value === 'COMPLETED') {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    });

    return (
        <>
            {showButton &&
                <div className="button-container">
                    <a className="button button--green insurely-done-btn" href={props.linkUrl} >
                        {props.linkText}
                    </a>
                </div>
            }
        </>
    )
};

export default ButtonComponent;